module.exports = __webpack_public_path__ + "static/media/exclamation.6a2f8692.svg";